<template>
  <div class="vx-row w-full">
    <!-- {{ nodePidHobjectNameDictionnary }} -->
    <!-- -->
    <!-- {{ hobjects }} -->
    <!-- {{ this.selected_action.id }} -->
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-3/12 xl:w-3/12">
      <vs-button class="w-5/12 mr-6" type="border" @click="$router.go(-1)" color="primary">Back</vs-button>
      <vs-button @click="updateSpace()" class="w-6/12" type="border" color="primary">Save</vs-button>
      <vx-card class="mt-4" title="Sequences">
        <div v-for="trigger_type in triggerTypeOptions" :key="trigger_type.value">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6" class="sm:p-0 p-4 text-left">
              <h6 :title="trigger_type.text">{{ trigger_type.text }}</h6>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="6" class="sm:p-0 p-4 text-center">
              <vs-button
                class="p-1 mb-1 inline-flex text-gray"
                v-on:click="AddSequence(trigger_type)"
                size="small"
                color="primary"
                type="flat"
                >Add New
              </vs-button>
            </vs-col>
          </vs-row>
          <div class="ml-4" v-for="seq in sequences" :key="seq.id">
            <vs-row
              v-if="seq.trigger.trigger_type.value == trigger_type.value"
              vs-type="flex"
              vs-justify="space-between"
            >
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="10" class="sm:p-0 p-4 text-left">
                <li
                  class="hover"
                  v-on:click="selected_trigger = seq"
                  v-if="seq.trigger.trigger_type.value == trigger_type.value"
                >
                  <template v-if="seq.name">{{ seq.name }}</template>
                  <template v-else> {{ showTriggerSubtitle(seq) }}</template>
                </li></vs-col
              >
              <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="2" class="sm:p-0 p-4 text-center">
                <feather-icon
                  icon="TrashIcon"
                  v-on:click="RemoveSequence(seq)"
                  svgClasses="h-4 w-4 cursor-pointer text-gray"
                  class="hover:text-danger mr-1"
                />
              </vs-col>
            </vs-row>
          </div>

          <vs-divider class="mt-1 mb-2"></vs-divider>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 mb-base">
      <vx-card v-if="selected_trigger">
        <div class="mb-4 flex">
          <div class="flex" v-if="!is_sequence_name_editing">
            <div class="header-sequence w-full">
              <h4 class="text mt-2 mr-4">{{ selected_trigger.name }}</h4>
              <vs-button
                type="flat"
                @click="enableSequenceNameEditing(selected_trigger.name)"
                class="mr-3 icon-size"
                icon="edit"
              ></vs-button>
              <vs-checkbox v-model="selected_trigger.repeat">Repeats</vs-checkbox>
            </div>
          </div>
          <div class="flex" v-if="is_sequence_name_editing">
            <vs-input v-model="temp_sequence_name" class="input" />
            <vs-button type="flat" class="mr-3 icon-size" icon="close" @click="disableSequenceNameEditing"></vs-button>
            <vs-button type="flat" class="mr-3 icon-size" icon="check" @click="saveSequenceNameEdit"></vs-button>
          </div>
        </div>
        <div class="editable-text"></div>
        <div class="timeline">
          <div class="outer">
            <div class="card">
              <div class="info">
                <h3 class="title"></h3>
                <div class="timeline-info">
                  <p class="font-semibold">Start when</p>

                  <!-- <span class="activity-desc">{{ selected_trigger.trigger.trigger_type.text }} </span> -->
                </div>
                <!-- <small class="text-grey activity-e-time">2Emin</small> -->

                <!-- <span>Trigger Type:</span> -->
                <v-select
                  :clearable="false"
                  v-model="selected_trigger.trigger.trigger_type"
                  label="text"
                  class="mb-2 w-full"
                  :options="triggerTypeOptions"
                />
                <!-- {{ selected_trigger.target }} -->
                <!-- <br /> -->
                <!-- {{ node_options }} -->
                <!-- {{ this.selected_trigger }} -->

                <div v-if="selected_trigger.trigger.trigger_type.value == 'trigger_match_to_place'">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vs-checkbox class="mb-3 mt-3" v-model="selected_trigger.show_preview">Show Preview</vs-checkbox>
                    </div>
                    <div v-show="selected_trigger.show_preview" class="vx-col w-1/2">
                      <span>Preview Text:</span>
                      <vs-input class="w-full mb-3" name="name" v-model="selected_trigger.preview_instructions_text" />
                    </div>
                    <div v-show="selected_trigger.show_preview" class="vx-col w-1/2">
                      <span>Preview Button Text:</span>
                      <vs-input class="w-full mb-3" name="name" v-model="selected_trigger.preview_button_text" />
                    </div>
                    <div class="vx-col w-full">
                      <span>Instructions Text:</span>
                      <vs-input class="w-full mb-3" name="name" v-model="selected_trigger.instructions_text" />
                    </div>
                    <div class="vx-col w-full">
                      <span>Instructions Button Text:</span>
                      <vs-input class="w-full mb-3" name="name" v-model="selected_trigger.instructions_button_text" />
                    </div>
                    <!-- <div class="vx-col w-1/2">
                      <span>Smooth Time (seconds):</span>
                      <vs-input-number
                        min="0"
                        max="100"
                        :step="0.25"
                        class="w-full mb-5"
                        v-model="selected_trigger.smooth_time"
                        icon-inc="expand_less"
                        icon-dec="expand_more"
                      />
                    </div>
                    <div class="vx-col w-1/2">
                      <span>Max speed:</span>
                      <vs-input-number
                        min="0"
                        max="100"
                        :step="0.25"
                        class="w-full mb-5"
                        v-model="selected_trigger.max_speed"
                        icon-inc="expand_less"
                        icon-dec="expand_more"
                      />
                    </div> -->
                  </div>
                </div>

                <div v-if="selected_trigger.trigger.trigger_type.value == 'trigger_amqp_message_received'">
                  <div class="vx-row">
                    <div class="vx-col w-1/3">
                      <span>Host:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.host" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Port:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.port" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Username:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.username" />
                    </div>
                  </div>

                  <div class="vx-row">
                    <div class="vx-col w-1/3">
                      <span>Password:</span>
                      <vs-input class="w-full mb-2" v-model="selected_trigger.password" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>VirtualHost:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.virtual_host" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Exchange:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.exchange" />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/3">
                      <span>Routing Key:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.routing_key" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>SelectedToken:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.selected_token" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Message:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.message" />
                    </div>
                  </div>
                </div>
                <div v-if="selected_trigger.trigger.trigger_type.value == 'trigger_mqtt_message_received'">
                  <div class="vx-row">
                    <div class="vx-col w-1/3">
                      <span>Host:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.host" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Username:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.username" />
                    </div>
                    <div class="vx-col w-1/3">
                      <span>Password:</span>
                      <vs-input class="w-full mb-2" v-model="selected_trigger.password" />
                    </div>
                  </div>

                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <span>Read Topic:</span>
                      <vs-input class="w-full mb-2" name="name" v-model="selected_trigger.read_topic" />
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    selected_trigger.trigger.trigger_type.value == 'trigger_screen_tap' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_image_anchor_lost'
                  "
                >
                  <div v-show="selected_trigger.trigger.trigger_type.value != 'trigger_screen_tap'">
                    <span>Reference Image:</span>
                    <v-select
                      :clearable="false"
                      v-model="selected_trigger.anchor"
                      label="name"
                      class="mb-3 w-full"
                      :options="referenceImageOptions"
                    />
                  </div>
                  <div
                    v-if="
                      selected_trigger.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                        selected_trigger.trigger.trigger_type.value == 'trigger_screen_tap'
                    "
                  >
                    <vs-checkbox class="mb-3" v-model="selected_trigger.show_instructions"
                      >Show instructions</vs-checkbox
                    >
                    <div v-if="selected_trigger.show_instructions">
                      <span>Instructions text:</span>
                      <vs-input class="w-full mb-3" name="name" v-model="selected_trigger.instructions_text" />
                      <!-- <span>Instructions text background</span>
                <vs-input
                  class="w-full mb-3"
                  placeholder="#000000"
                  name="name"
                  v-model="selected_trigger.instructions_text_background"
                /> -->
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    selected_trigger.trigger.trigger_type.value == 'trigger_tap' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_enter_portal' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_exit_portal' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_proximity_exit'
                  "
                >
                  <span>Object(s):</span>
                  <v-select
                    :clearable="false"
                    v-model="selected_trigger.targets"
                    multiple
                    label="text"
                    class="mb-2 w-full"
                    :options="nodePidHobjectNameOptions"
                  />
                </div>
                <div
                  v-if="
                    selected_trigger.trigger.trigger_type.value == 'trigger_match_to_place' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_tap_to_place'
                  "
                >
                  <span>Object to use as stencil</span>
                  <v-select
                    v-model="selected_trigger.target"
                    label="text"
                    class="mb-2 w-full"
                    :options="nodePidHobjectNameOptions"
                  />
                </div>
                <div
                  v-if="
                    selected_trigger.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_proximity_exit'
                  "
                >
                  <span>Distance (meters):</span>
                  <vs-input
                    min="0"
                    max="10000"
                    :step="1"
                    class="w-full mb-5"
                    v-model="selected_trigger.distance"
                    icon-inc="expand_less"
                    icon-dec="expand_more"
                  />
                </div>
                <center>
                  <!-- <vs-icon @click.stop="removeTrigger(selected_trigger)" icon="delete" size="medium" color="primary"></vs-icon> -->
                </center>
                <div
                  v-if="
                    selected_trigger.trigger.trigger_type.value == 'trigger_tap' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_screen_tap' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_enter_portal' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_exit_portal' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                      selected_trigger.trigger.trigger_type.value == 'trigger_proximity_exit'
                  "
                ></div>
              </div>
            </div>
            <draggable :list="selected_actions" :actions="selected_actions">
              <div
                v-for="action in selected_actions"
                :key="action.id"
                :name="action.id"
                :class="[selected_action && selected_action.id == action.id ? 'selected-card' : '', 'card']"
              >
                <div>
                  <div class="info">
                    <h3 v-if="action.start.value == 'after_previous'" class="title"></h3>
                    <div class="vx-row">
                      <div v-on:click="SelectAction(action.id, action)" class="vx-col w-10/12">
                        <div>
                          <div class="flex">
                            <vs-button
                              color="primary"
                              disabled
                              type="flat"
                              class=" icon-size"
                              :icon="iconActionDic[action.type]"
                            ></vs-button>
                            <p class="ml-2 mt-2 action-title-highlight font-semibold">
                              <span>
                                {{ showActionSubtitle(action) }}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div v-if="action.show" class="vx-row">
                          <!-- <div class="vx-col w-4/12">
                        <div class="mt-2">{{ showObjectsSummarize(action) }}</div>
                      </div>
                      <div class="vx-col w-6/12">
                        <v-select
                          :clearable="false"
                          v-model="action.type"
                          label="text"
                          class="w-full"
                          :options="actionTypes"
                        />
                      </div>

                      <div class="vx-col w-2/12">
                        <div class="mt-2">{{ showActionDuration(action) }}</div>
                      </div> -->
                        </div>
                        <!-- <span class="activity-desc">
                      {{ showActionSubtitle(action) }}
                    </span> -->

                        <!-- <p v-else class="font-semibold">{{ action.type.text }}</p> -->
                      </div>
                      <div class="vx-col w-2/12">
                        <vs-row vs-type="flex" vs-justify="flex-end">
                          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                            <vs-icon
                              v-on:click="removeAction(action)"
                              icon="delete"
                              size="small"
                              color="primary"
                            ></vs-icon>
                          </vs-col>
                        </vs-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>

        <div class="vx-row mt-5 ml-2">
          <!-- <div class="vx-full "><span>Action: </span></div> -->
          <span class="mt-3 text-gray">Add a new action:</span>
          <div class="flex">
            <vx-tooltip text="Show">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_show')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_show']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Hide">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_hide')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_hide']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Play">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_play')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_play']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Pause">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_pause')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_pause']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Stop">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_stop')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_stop']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Spin">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_spin')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_spin']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Animate">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_animate')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_animate']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Play Particles">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_play_particles')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_play_particles']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Change Space">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_change_space')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_change_space']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Open Link">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_open_url')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_open_url']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Show Instruction">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_show_instructions')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_show_instructions']"
              ></vs-button>
            </vx-tooltip>
            <!-- <vx-tooltip text="Set Experience Origin">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_set_experience_origin')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_set_experience_origin']"
              ></vs-button>
            </vx-tooltip> -->
            <vx-tooltip text="Start Tagging Along Screen">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_start_following')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_start_following']"
              ></vs-button>
            </vx-tooltip>
            <vx-tooltip text="Stop Tagging Along Screen">
              <vs-button
                color="primary"
                type="border"
                @click="AddAction('action_stop_following')"
                class=" mt-4 mr-3 icon-size"
                :icon="iconActionDic['action_stop_following']"
              ></vs-button>
            </vx-tooltip>
          </div>
          <!-- <div class="vx-col w-7/12">
            <span>Action: </span>
            <v-select
              :clearable="false"
              v-model="selected_action_type"
              label="text"
              class="w-full"
              :options="actionTypes"
            />
          </div>
          <div class="vx-col w-5/12">
            <vs-button
              v-if="this.selected_trigger"
              @click="AddAction()"
              class="w-full mr-4 mt-6"
              type="border"
              color="primary"
              >Add Action</vs-button
            >
          </div> -->
        </div>
      </vx-card>

      <div class="vx-col w-full mb-base">
        <!-- <vx-card class="mb-4">
        <vs-checkbox v-model="show_sequencing_json">Show JSON (Advanced User Only)</vs-checkbox>
        <vue-json-pretty v-if="show_sequencing_json" :path="'res'" :data="buildJsonSequence()"> </vue-json-pretty>
      </vx-card> -->
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-5/12 xl:w-5/12 mb-base">
      <vx-card v-if="selected_actions && selected_actions.length > 0 && !selected_action" title="Action">
        <p>Select an action to change its properties</p></vx-card
      >
      <div v-else-if="selected_action">
        <vx-card title="Action Inspector">
          <vs-collapse accordion type="border">
            <vs-collapse-item>
              <div slot="header">Timing</div>
              <div class="vx-row">
                <div v-if="selected_action != selected_actions[0]" class="vx-col w-1/2">
                  <span>Start:</span>
                  <v-select
                    :clearable="false"
                    v-model="selected_action.start"
                    label="text"
                    class="w-full mb-2"
                    :options="actionsStartOptions"
                  />
                </div>
                <div class="vx-col w-1/2">
                  <span>Delay: (seconds)</span>
                  <vs-input
                    min="0"
                    max="10000"
                    :step="0.5"
                    class="w-full mb-5"
                    v-model="selected_action.delay"
                    icon-inc="expand_less"
                    icon-dec="expand_more"
                  />
                </div>
                <div v-if="selected_action != selected_actions[0]" class="vx-col w-full mb-3">
                  <div v-if="selected_action.start.value == 'after_previous'">
                    Starts when previous action finishes.
                  </div>
                  <div v-else>Starts simultaneously with the previous selected_action.</div>
                </div>
                <div class="vx-col w-1/2">
                  <span>Repeat</span>
                  <vs-input
                    min="0"
                    max="10000"
                    :step="1"
                    class="w-full mb-5"
                    v-model="selected_action.repeat"
                    icon-inc="expand_less"
                    icon-dec="expand_more"
                  />
                </div>
                <div
                  v-if="selected_action.hasOwnProperty('wait_until_finished') || selected_action.type == 'action_play'"
                  class="vx-col w-full"
                >
                  <vs-checkbox class="mb-5" v-model="selected_action.wait_until_finished"
                    ><template v-if="selected_action.type == 'action_open_url'">Wait until closed</template
                    ><template v-else>Wait until finished</template>
                  </vs-checkbox>
                </div>
              </div>
            </vs-collapse-item>
            <vs-collapse-item>
              <div slot="header">Selected Object(s)</div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div
                    v-if="
                      selected_action.type == 'action_change_space' ||
                        selected_action.type == 'action_set_experience_origin' ||
                        selected_action.type == 'action_open_url' ||
                        selected_action.type == 'action_show_instructions' ||
                        selected_action.type == 'action_send_amqp_message' ||
                        selected_action.type == 'action_send_mqtt_message'
                    "
                  >
                    <div>Not Applicable</div>
                  </div>
                  <div v-else>
                    <vs-checkbox class="mb-5" v-model="selected_action.target_all_objects"
                      >If checked, all objects are selected
                    </vs-checkbox>
                    <div v-show="!selected_action.target_all_objects">
                      <span>Selected Object(s):</span>
                      <v-select
                        :clearable="false"
                        v-model="selected_action.targets"
                        multiple
                        label="text"
                        class="w-full mb-2"
                        :options="nodePidHobjectNameOptions"
                      />
                    </div>
                  </div>
                </div></div
            ></vs-collapse-item>
            <template
              v-if="
                selected_action.type != 'action_show' &&
                  selected_action.type != 'action_hide' &&
                  selected_action.type != 'action_open_url' &&
                  selected_action.type != 'action_play_particles' &&
                  selected_action.type != 'action_send_amqp_message' &&
                  selected_action.type != 'action_send_mqtt_message' &&
                  selected_action.type != 'action_animate' &&
                  selected_action.type != 'action_show' &&
                  selected_action.type != 'action_spin' &&
                  selected_action.type != 'action_transform_to' &&
                  selected_action.type != 'action_transform_by' &&
                  selected_action.type != 'action_change_space' &&
                  selected_action.type != 'action_start_following' &&
                  selected_action.type != 'action_show_instructions'
              "
            ></template>
            <template v-else>
              <vs-collapse-item>
                <div slot="header">Options</div>
                <div v-if="selected_action_clone" class="tab-general md:ml-4 md:mt-0 mt-0 ml-0">
                  <FormulateForm
                    v-if="selected_action.type == 'action_show'"
                    :values="selected_action_clone"
                    @events="onEvents"
                    :schema="action_show_form_schema"
                    :ferrors="{}"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_hide'"
                    @events="onEvents"
                    :values="selected_action_clone"
                    :schema="action_hide_form_schema"
                    :ferrors="{}"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_spin'"
                    :values="selected_action_clone"
                    @events="onEvents"
                    :schema="action_spin_form_schema"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_transform_to'"
                    :values="selected_action_clone"
                    @events="onEvents"
                    :schema="action_transform_to"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_transform_by'"
                    :values="selected_action_clone"
                    @events="onEvents"
                    :schema="action_transform_by"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_animate'"
                    :values="selected_action_clone"
                    :schema="action_animate_form_schema"
                    @events="onEvents"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_play_particles'"
                    :values="selected_action_clone"
                    :schema="action_play_particles_form_schema"
                    @events="onEvents"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_open_url'"
                    :values="selected_action_clone"
                    :schema="action_open_url_form_schema"
                    @events="onEvents"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_change_space'"
                    :values="selected_action_clone"
                    :schema="action_change_space_form_schema"
                    @events="onEvents"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_show_instructions'"
                    :values="selected_action_clone"
                    :schema="action_show_instructions_form_schema"
                    @events="onEvents"
                  />
                  <FormulateForm
                    v-if="selected_action.type == 'action_start_following'"
                    :values="selected_action_clone"
                    :schema="action_start_following_form_schema"
                    @events="onEvents"
                  />
                </div>
              </vs-collapse-item>
            </template>
          </vs-collapse>
        </vx-card>
      </div>
      <div v-else>
        <vx-card title="Action Inspector">To create an action click on "Add Action"</vx-card>
      </div>
    </div>

    <!-- <vx-card class="mb-4">
        <vs-checkbox v-model="show_sequencing_json">Show JSON (Advanced User Only)</vs-checkbox>
        <vue-json-pretty v-if="show_sequencing_json" :path="'res'" :data="buildJsonSequence()"> </vue-json-pretty>
      </vx-card> -->
    <vx-card :card-background="getBackgroundColor(selected_trigger)" @click.stop="selectTrigger(selected_trigger)">
    </vx-card>
    <vx-card class="w-3/12 mb-4">
      <vs-checkbox v-model="show_sequencing_json">Show JSON</vs-checkbox>
      <vue-json-pretty v-if="show_sequencing_json" :path="'res'" :data="buildJsonSequence()"> </vue-json-pretty>

      <!--       
      <vs-checkbox v-model="show_vue_sequencing_json">Show JSON</vs-checkbox>
      <vue-json-pretty v-if="show_vue_sequencing_json" :path="'res'" :data="this.sequences"> </vue-json-pretty> -->
    </vx-card>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import draggable from 'vuedraggable'
import { uuid } from 'vue-uuid'
import vSelect from 'vue-select'
import VxCard from '../../../../components/vx-card/VxCard.vue'
import 'vue-select-image/dist/vue-select-image.css'
import '@braid/vue-formulate/themes/snow/snow.scss'

// Forms
import { actionShowSchema, actionShowValue } from './forms/ActionShow.js'
import { actionHideSchema, actionHideValue } from './forms/ActionHide.js'
import { actionAnimateSchema, actionAnimateValue } from './forms/ActionAnimate.js'
import { actionSpinSchema, actionSpinValue } from './forms/ActionSpin.js'
import { actionTransformToSchema, actionTransformToValue } from './forms/ActionTransformTo.js'
import { actionTransformBySchema, actionTransformByValue } from './forms/ActionTransformBy.js'
import { actionPlayParticlesSchema, actionPlayParticlesValue } from './forms/ActionPlayParticules.js'
import { actionOpenUrlSchema, actionOpenUrlValue } from './forms/ActionOpenUrl.js'
import { actionChangeSpaceSchema, actionChangeSpaceValue } from './forms/ActionChangeSpace.js'
import { actionShowInstructionSchema, actionShowInstructionValue } from './forms/ActionShowInstruction.js'
import { actionStartFollowingSchema, actionStartFollowingValue } from './forms/ActionStartFollowing.js'

// Form events
import { ref } from '@vue/composition-api'

export default {
  inject: ['$validator'],
  data() {
    return {
      events: ref([]),
      values: {},
      action_show_form_schema: actionShowSchema,
      action_hide_form_schema: actionHideSchema,
      action_animate_form_schema: actionAnimateSchema,
      action_spin_form_schema: actionSpinSchema,
      action_transform_to: actionTransformToSchema,
      action_transform_by: actionTransformBySchema,
      action_play_particles_form_schema: actionPlayParticlesSchema,
      action_open_url_form_schema: actionOpenUrlSchema,
      action_change_space_form_schema: actionChangeSpaceSchema,
      action_show_instructions_form_schema: actionShowInstructionSchema,
      action_start_following_form_schema: actionStartFollowingSchema,
      layer_name: JSON.parse(localStorage.getItem('layerInfo')).name,
      selected_trigger: null,
      actionTabIndex: 1,
      selected_actions: null,
      selected_action: null,
      selected_action_clone: null,
      selected_action_type: { text: 'Animate Entrance', value: 'action_show' },
      sequences: [],
      triggerTypeOptions: [],
      selectedReferenceImage: null,
      referenceImageOptions: null,
      actionsStartDic: {
        with_previous: 'with previous',
        after_previous: 'after previous',
      },
      spacePidNameOptions: [],
      entranceTypeOptions: [],
      exitTypeOptions: [],
      nodePidHobjectNameOptions: [],
      actionsStartOptions: [],
      axisOptions: [],
      directionOptions: [],
      axisDic: {
        right: 'Right',
        up: 'Up',
        rear: 'Rear',
      },
      directionDic: {
        clockwise: 'Clockwise',
        counterclockwise: 'Counterclockwise',
      },
      triggerTypesDic: {
        trigger_experience_starts: 'Immediately',
        // near_range_in: 'Near Range In',
        trigger_image_anchor_found: 'Image Found',
        trigger_tap: 'Object Tapped',
        trigger_match_to_place: 'Match to Place',
        trigger_tap_to_place: 'Tap to Place',
        trigger_screen_tap: 'Screen Tap',
        trigger_enter_portal: 'Enter Portal',
        trigger_exit_portal: 'Exit Portal',
        trigger_proximity_enter: 'Enter Proximity',
        trigger_proximity_exit: 'Exit Proximity',
        // trigger_image_anchor_lost: 'Image Lost',
        // trigger_mqtt_message_received: 'MQTT Message Received',
        // trigger_amqp_message_received: 'AMQP Message Received',
      },
      iconActionDic: {
        action_show: 'visibility',
        action_hide: 'visibility_off',
        action_play: 'play_arrow',
        action_pause: 'pause',
        action_stop: 'stop',
        action_animate: 'animation',
        action_spin: '360',
        action_transform_to: 'move_up',
        action_transform_by: 'photo_size_select_small',
        action_play_particles: 'snowing',
        action_change_space: 'double_arrow',
        action_open_url: 'link',
        action_show_instructions: 'notes',
        action_set_experience_origin: 'ads_click',
        action_start_following: 'phonelink_lock',
        action_stop_following: 'phonelink_erase',
        action_send_amqp_message: 'SendIcon',
        action_send_mqtt_message: 'SendIcon',
      },
      actionTypesDic: {
        action_show: 'Animate Entrance',
        action_hide: 'Animate Exit',
        action_play: 'Play',
        action_pause: 'Pause',
        action_stop: 'Stop',
        action_animate: 'Animate',
        action_spin: 'Spin',
        action_play_particles: 'Play Particles',
        action_change_space: 'Change Space',
        action_open_url: 'Open Link',
        action_show_instructions: 'Show Instruction',
        action_set_experience_origin: 'Set Experience Origin',
        // action_send_amqp_message: 'Send AMQP message ',
        // action_send_mqtt_message: 'Send MQTT message ',
      },
      actionTypes: [],
      show_sequencing_json: false,
      show_vue_sequencing_json: false,
      is_sequence_name_editing: false,
      temp_sequence_name: null,
    }
  },
  props: {
    space: {},
    hobjects: {},
    nodes: {},
    anchors_spaces: {},
    anchors: {},
    nodePidHobjectNameDictionnary: {},
    spacePidNameDictionnary: {},
  },
  components: {
    VueJsonPretty,
    draggable,
    'v-select': vSelect,
    VxCard,
  },
  watch: {
    selected_trigger: function(updatedValue) {
      console.log('selected_trigger')
      console.log(updatedValue)
      if (updatedValue) this.selected_actions = updatedValue.actions
    },
    selected_action: function(updatedValue) {
      this.selected_action_clone = null
      // Clone selected_action in the next tick (to overcome vue-formulate issue)
      this.$nextTick(() => {
        this.selected_action_clone = JSON.parse(JSON.stringify(updatedValue))
      })
    },
  },
  computed: {
    space_pid: function() {
      return this.$route.params.pid
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
  },
  mounted() {},
  async created() {
    // Populate dictionnaries
    for (const [key, value] of Object.entries(this.actionTypesDic)) {
      this.actionTypes.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.spacePidNameDictionnary)) {
      this.spacePidNameOptions.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.nodePidHobjectNameDictionnary)) {
      this.nodePidHobjectNameOptions.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.triggerTypesDic)) {
      this.triggerTypeOptions.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.actionsStartDic)) {
      this.actionsStartOptions.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.directionDic)) {
      this.directionOptions.push({ text: value, value: key })
    }
    for (const [key, value] of Object.entries(this.axisDic)) {
      this.axisOptions.push({ text: value, value: key })
    }

    // Populate ActionChangeSpaceFormSchema
    this.action_change_space_form_schema[0].options = this.spacePidNameDictionnary

    // Populate reference for ActionChangeSpace when keep_origin is true
    // this.action_change_space_form_schema[2].options = this.nodePidHobjectNameDictionnary

    this.referenceImageOptions = []
    this.anchors_spaces.forEach(as => {
      if (as.anchor.anchor_type == 'image' || as.anchor.anchor_type == 'vuforia-instant-image-target')
        this.referenceImageOptions.push({
          id: as.anchor.pid,
          name: as.anchor.name,
          src: as.anchor.data,
          value: as.anchor.pid,
          alt: 'none',
        })
    })

    // console.log(this.space.storylines)
    if (
      this.space.storylines == null ||
      this.space.storylines.sequences == null ||
      !this.isValid(this.space.storylines.sequences)
    ) {
      this.AddSequence(null)
    } else {
      this.sequences = this.deserialize(this.space.storylines.sequences)
    }
    // console.log(this.sequences[0])
    this.selected_trigger = this.sequences[0]
  },
  methods: {
    showActionDuration(action) {
      var text = ''
      if (action.duration > 0) text += ` in ${action.duration}s`
      return text
    },
    showTriggerSubtitle(sequence) {
      if (!sequence.targets) return sequence.name
      var hobjectName = sequence.targets[0] ? sequence.targets[0].text : sequence.name
      var othersHobject = ''
      if (sequence.targets.length == 2) {
        othersHobject = `+ ${sequence.targets.length - 1} other `
      }
      if (sequence.targets.length > 2) {
        othersHobject = `+ ${sequence.targets.length - 1} others `
      }
      return `${hobjectName} ${othersHobject}`
    },
    showActionSubtitle(action) {
      var text = ''
      var hobjectName = ''
      var othersHobject = ''
      var verbTermination = ''

      if (action.target_all_objects == true) {
        hobjectName = 'All objects'
      } else {
        if (action.targets) {
          hobjectName = action.targets[0] ? action.targets[0].text : ''
          if (action.targets.length == 2) {
            othersHobject = `(+ ${action.targets.length - 1}) `
          }
          if (action.targets.length > 2) {
            othersHobject = `(+ ${action.targets.length - 1})`
          }
          verbTermination = action.targets.length == 1 ? 'S' : ''
        }
      }

      if (action.type == 'action_show') text = `${hobjectName} ${othersHobject} ENTER` + verbTermination
      if (action.type == 'action_hide') text = `${hobjectName} ${othersHobject} EXIT` + verbTermination
      if (action.type == 'action_play') text = `${hobjectName} ${othersHobject} PLAY` + verbTermination
      if (action.type == 'action_pause') text = `${hobjectName} ${othersHobject} PAUSE` + verbTermination
      if (action.type == 'action_stop') text = `${hobjectName} ${othersHobject} STOP` + verbTermination
      if (action.type == 'action_animate') text = `PLAY ANIMATION on ${hobjectName} ${othersHobject}`
      if (action.type == 'action_spin') text = `SPIN on ${hobjectName} ${othersHobject}`
      if (action.type == 'action_transform_to') text = `Move, Rotate, Scale to`
      if (action.type == 'action_transform_by') text = `Move, Rotate, Scale by`
      if (action.type == 'action_play_particles') text = `PLAY PARTICLES on ${hobjectName} ${othersHobject}`
      if (action.type == 'action_send_amqp_message') text = `SEND ${action.message} to ${action.host}`
      if (action.type == 'action_send_mqtt_message') text = `SEND ${action.message} to ${action.host}`
      if (action.type == 'action_change_space') text = 'Change space'
      if (action.type == 'action_show_instructions') text = 'Show Instruction'
      if (action.type == 'action_open_url') text = 'Open Link'
      if (action.type == 'action_set_experience_origin') text = 'Reset Exp Origin'
      if (action.type == 'action_start_following') text = 'Start Tagging Along Screen'
      if (action.type == 'action_stop_following') text = 'Stop Tagging Along Screen'

      return text
    },
    removeTrigger: function(t) {
      console.log('removeTrigger')
      const index = this.sequences.indexOf(t)
      if (index > -1) {
        this.sequences.splice(index, 1)
      }

      if (this.selected_trigger == null && this.sequences.length > 0) this.selected_trigger = this.sequences[0]
    },
    removeAction: function(a) {
      if (this.selected_action && this.selected_action.id == a.id) this.selected_action = undefined
      this.sequences.forEach(trigger => {
        var action = trigger.actions.find(action => action.id == a.id)
        if (action) {
          const index = trigger.actions.indexOf(action)
          if (index > -1) {
            trigger.actions.splice(index, 1)
          }
          console.log(action)
        }
        // console.log(action)
      })
    },
    RemoveSequence: function(sequence) {
      var index
      var tmp
      if (sequence) tmp = this.sequences.find(seq => seq.id == sequence.id)
      else tmp = this.sequences.find(seq => seq.id == this.selected_trigger.id)
      index = this.sequences.indexOf(tmp)

      console.log(this.sequences)
      console.log(sequence)
      console.log(index)

      if (index > 0) {
        this.selected_trigger = this.sequences[index - 1]
      } else {
        this.selected_trigger = null
      }
      if (index > -1) {
        this.sequences.splice(index, 1) // 2nd parameter means remove one item only
      }

      console.log(this.sequences)
    },
    AddSequence: function(trigger_type) {
      if (!trigger_type) trigger_type = { value: 'trigger_experience_starts', text: 'Immediately' }
      this.sequences.push({
        name: `Sequence ${this.sequences.length + 1}`,
        actions: [],
        trigger: { trigger_type: trigger_type, id: uuid.v4() },
        id: uuid.v4(),
      })
      this.selected_trigger = this.sequences[this.sequences.length - 1]
      // console.log(this.selected_trigger)
    },
    AddAction(selected_action_type) {
      const actionId = uuid.v4()
      var commonProperties = {
        id: actionId,
        type: selected_action_type,
        start: { value: 'after_previous', text: 'After Previous' },
        targets: [{ text: this.nodePidHobjectNameDictionnary[this.nodes[0].pid], value: this.nodes[0].pid }],
        delay: 0,
        repeat: 0,
      }
      var actionProperties = {}
      if (selected_action_type == 'action_spin') actionProperties = actionSpinValue
      if (selected_action_type == 'action_transform_by') actionProperties = actionTransformByValue
      if (selected_action_type == 'action_transform_to') actionProperties = actionTransformToValue
      if (selected_action_type == 'action_show') actionProperties = actionShowValue
      if (selected_action_type == 'action_hide') actionProperties = actionHideValue
      if (selected_action_type == 'action_animate') actionProperties = actionAnimateValue
      if (selected_action_type == 'action_play_particles') actionProperties = actionPlayParticlesValue
      if (selected_action_type == 'action_open_url') actionProperties = actionOpenUrlValue
      if (selected_action_type == 'action_show_instructions') actionProperties = actionShowInstructionValue
      if (selected_action_type == 'action_start_following') actionProperties = actionStartFollowingValue
      this.selected_trigger.actions.push({
        ...actionProperties,
        ...commonProperties,
      })
      // Then select the action we just added
      this.SelectAction(actionId)
      // Selected second action tab by default
      this.actionTabIndex = 1
    },
    selectTrigger(trigger) {
      console.log(trigger)
      this.selected_trigger = trigger
    },
    getBackgroundColor() {
      return '#2816df'
      // if (this.selected_trigger && this.selected_trigger.id == trigger.id) return '#8379f2'
      // else return '#e9e7fd'
    },
    async updateSpace() {
      await this.$store.dispatch('hoverlay/updateSpace', {
        pid: this.space_pid,
        storylines: { sequences: this.buildJsonSequence() },
      })
      this.$vs.notify({
        text: 'Sequences saved',
        color: 'success',
        icon: 'check_box',
      })
    },
    getActionClass(action) {
      if (action.start.value == 'after_previous') return 'mb-5'
      else return null
    },

    // DESERIALIZER
    deserialize: function(json) {
      // json = [
      //   {
      //     type: 'sequential',
      //     elements: [
      //       { type: 'trigger_experience_starts', targets: [{ text: '4ee99d8a-e-RealityLab', value: 'gtceb' }] },
      //       {
      //         type: 'parallel',
      //         elements: [
      //           { type: 'show', targets: ['gtceb'], duration: 1, delay: 3 },
      //           { type: 'hide', targets: ['gtceb'], duration: 2, delay: 4 },
      //         ],
      //       },
      //       // {
      //       //   type: 'parallel',
      //       //   elements: [
      //       //     { type: 'show3', targets: ['gtceb'], duration: 0, delay: 0 },
      //       //     { type: 'show4', targets: ['gtceb'], duration: 0, delay: 0 },
      //       //   ],
      //       // },
      //     ],
      //   },
      // ]

      var sequences = []

      json.forEach(sequence => {
        var s = {
          trigger: {
            id: sequence.elements[0].id,
            trigger_type: { value: sequence.elements[0].type, text: this.triggerTypesDic[sequence.elements[0].type] },
          },
          targets: this.getElementTargets(sequence.elements[0]),
          target: this.getElementTarget(sequence.elements[0]),
          actions: [],
          id: sequence.id,
          name: sequence.name,
        }
        // trigger_image_anchor_found
        // trigger_image_anchor_lost
        if (
          sequence.elements[0].type == 'trigger_image_anchor_found' ||
          sequence.elements[0].type == 'trigger_image_anchor_lost'
        ) {
          console.log(sequence.elements[0].anchor)
          if (sequence.elements[0].anchor != null) {
            var a = this.referenceImageOptions.find(ref => ref.id == sequence.elements[0].anchor)
            s.anchor = a
            console.log(s)
            var anchor = this.anchors.find(a => a.pid == sequence.elements[0].anchor)
            s.selectedReferenceImage = {
              id: anchor.pid,
              src: anchor.data,
              value: anchor.pid,
              alt: 'none',
            }
          }
        }

        if (
          sequence.elements[0].type == 'trigger_image_anchor_found' ||
          sequence.elements[0].type == 'trigger_image_anchor_lost' ||
          sequence.elements[0].type == 'trigger_screen_tap'
        ) {
          s.instructions_text = sequence.elements[0].instructions_text
          s.show_instructions = sequence.elements[0].show_instructions
          // s.instructions_text_background = sequence.elements[0].instructions_text_background
        }
        if (sequence.elements[0].type == 'trigger_match_to_place') {
          s.preview_instructions_text = sequence.elements[0].preview_instructions_text
          s.preview_button_text = sequence.elements[0].preview_button_text
          s.instructions_text = sequence.elements[0].instructions_text
          s.instructions_button_text = sequence.elements[0].instructions_button_text
          s.show_preview = sequence.elements[0].show_preview
          s.smooth_time = sequence.elements[0].smooth_time
          s.max_speed = sequence.elements[0].max_speed
        }
        // trigger_mqtt_message_received
        if (sequence.elements[0].type == 'trigger_mqtt_message_received') {
          s.host = sequence.elements[0].host
          s.username = sequence.elements[0].username
          s.password = sequence.elements[0].password
          s.read_topic = sequence.elements[0].read_topic
        }

        // trigger_amqp_message_received
        if (sequence.elements[0].type == 'trigger_amqp_message_received') {
          s.host = sequence.elements[0].host
          s.username = sequence.elements[0].username
          s.password = sequence.elements[0].password
          s.port = sequence.elements[0].port
          s.read_topic = sequence.elements[0].read_topic
          s.exchange = sequence.elements[0].exchange
          s.routing_key = sequence.elements[0].routing_key
          s.virtual_host = sequence.elements[0].virtual_host
          s.selected_token = sequence.elements[0].selected_token
          s.message = sequence.elements[0].message
        }

        // trigger_amqp_message_received
        if (
          sequence.elements[0].type == 'trigger_proximity_enter' ||
          sequence.elements[0].type == 'trigger_proximity_exit'
        ) {
          s.distance = parseFloat(sequence.elements[0].distance)
        }

        for (let y = 1; y < sequence.elements.length; y++) {
          // console.log(sequence.elements[y])
          if (sequence.elements[y].type == 'parallel') {
            // console.log('parallel')
            s.actions.push(this.deserializeElement(sequence.elements[y].elements[0], 'after_previous'))
            for (let i = 1; i < sequence.elements[y].elements.length; i++) {
              s.actions.push(this.deserializeElement(sequence.elements[y].elements[i], 'with_previous'))
            }
          } else {
            // console.log('seq ')

            s.actions.push(this.deserializeElement(sequence.elements[y], 'after_previous'))
          }
        }
        if (sequence.name) s.name = sequence.name
        else s.name = `Sequence ${json.indexOf(sequence) + 1}`

        // Repeat
        if (sequence.repeat == -1 || sequence.repeat == true) s.repeat = true
        else s.repeat = false

        sequences.push(s)
      })
      // console.log(sequences)
      return sequences
    },
    getHobjectAnimationFromNodePid(nodePid) {
      var hobjectPid = this.nodes.find(n => n.pid == nodePid).hobject_pid
      var h = this.hobjects.find(h => h.pid == hobjectPid)
      var abilities = JSON.parse(h.abilities)
      if (abilities.gltf_loader) return abilities.gltf_loader.animation_clip_names
    },
    getElementTarget: function(element) {
      var target = ''
      if (element.target) return { text: this.nodePidHobjectNameDictionnary[element.target], value: element.target }
      else return target
    },
    getElementTargets: function(element) {
      var targets = []
      if (element.targets && element.targets.length > 0)
        element.targets.forEach(target => {
          targets.push({ text: this.nodePidHobjectNameDictionnary[target], value: target })
        })
      return targets
    },

    deserializeElement: function(element, start_after) {
      // create copy
      element = JSON.parse(JSON.stringify(element))
      var targets = []
      if (element.targets) {
        console.log('deserializeElement')
        element.targets.forEach(target => {
          console.log(target)
          targets.push({ text: this.nodePidHobjectNameDictionnary[target], value: target })
        })
      }
      element.targets = targets
      element.start = {
        value: start_after,
        text: this.actionsStartDic[start_after],
      }
      return element
    },

    /// SERIALIZER
    buildJsonSequenceElement: function(action) {
      // Duplicate action
      action = JSON.parse(JSON.stringify(action))
      // Action may or may not have associated target(s)
      if (action.targets && action.targets.length > 0) {
        var targets = []
        action.targets.forEach(target => {
          targets.push(target.value)
        })
        action.targets = targets
      }
      if (action.start) action.start = action.start.value
      return action
    },
    buildJsonparallel: function(actions) {
      var block = { type: 'parallel', elements: [] }
      for (let index = 0; index < actions.length; index++) {
        const action = actions[index]
        block.elements.push(this.buildJsonSequenceElement(action))
      }
      return block
    },
    buildJsonSequence: function() {
      var json = []
      this.sequences.forEach(sequence => {
        if (sequence.actions != null && sequence.actions.length > 0) {
          var el = {
            type: 'sequential',
            repeat: sequence.repeat == true ? -1 : 0,
            id: sequence.id,
            name: sequence.name,
            elements: [
              {
                type:
                  sequence.trigger.trigger_type != null && sequence.trigger.trigger_type.value != null
                    ? sequence.trigger.trigger_type.value
                    : null,
              },
            ],
          }
          el.elements[0].id = sequence.trigger.id
          if (sequence.trigger.trigger_type.value == 'trigger_screen_tap') {
            el.elements[0].instructions_text = sequence.instructions_text
            el.elements[0].show_instructions = sequence.show_instructions
          }
          if (
            (sequence.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
              sequence.trigger.trigger_type.value == 'trigger_image_anchor_lost') &&
            sequence.anchor
          ) {
            // trigger_image_anchor_found & trigger_image_anchor_lost
            // Add anchor to sequence trigger if needed
            el.elements[0].anchor = sequence.anchor.id
            el.elements[0].instructions_text = sequence.instructions_text
            el.elements[0].show_instructions = sequence.show_instructions
            // el.elements[0].instructions_text_background = sequence.instructions_text_background
          }
          if (sequence.trigger.trigger_type.value == 'trigger_tap_to_place') {
            el.elements[0].target = sequence.target ? sequence.target.value : null
          }

          if (sequence.trigger.trigger_type.value == 'trigger_match_to_place') {
            el.elements[0].target = sequence.target ? sequence.target.value : null
            // el.elements[0].targets = Array.from(sequence.targets, target => target.value)
            el.elements[0].preview_instructions_text = sequence.preview_instructions_text
            el.elements[0].preview_button_text = sequence.preview_button_text
            el.elements[0].instructions_button_text = sequence.instructions_button_text
            el.elements[0].show_preview = sequence.show_preview
            el.elements[0].smooth_time = sequence.smooth_time
            el.elements[0].max_speed = sequence.max_speed
          }
          // trigger_mqtt_message_received
          if (sequence.trigger.trigger_type.value == 'trigger_mqtt_message_received') {
            el.elements[0].host = sequence.host
            el.elements[0].username = sequence.username
            el.elements[0].password = sequence.password
            el.elements[0].read_topic = sequence.read_topic
          }
          //trigger_amqp_message_received
          if (sequence.trigger.trigger_type.value == 'trigger_amqp_message_received') {
            el.elements[0].host = sequence.host
            el.elements[0].port = sequence.port
            el.elements[0].username = sequence.username
            el.elements[0].password = sequence.password
            el.elements[0].virtual_host = sequence.virtual_host
            el.elements[0].exchange = sequence.exchange
            el.elements[0].routing_key = sequence.routing_key
            el.elements[0].selected_token = sequence.selected_token
            el.elements[0].message = sequence.message
          }

          // trigger_tap
          if (sequence.trigger.trigger_type.value == 'trigger_tap' && sequence.targets) {
            el.elements[0].targets = Array.from(sequence.targets, target => target.value)
          }
          // trigger_enter_portal
          if (sequence.trigger.trigger_type.value == 'trigger_enter_portal' && sequence.targets) {
            el.elements[0].targets = Array.from(sequence.targets, target => target.value)
          }
          // trigger_exit_portal
          if (sequence.trigger.trigger_type.value == 'trigger_exit_portal' && sequence.targets) {
            el.elements[0].targets = Array.from(sequence.targets, target => target.value)
          }
          // trigger_proximity_enter
          if (sequence.trigger.trigger_type.value == 'trigger_proximity_enter' && sequence.targets) {
            el.elements[0].targets = Array.from(sequence.targets, target => target.value)
            el.elements[0].distance = parseFloat(sequence.distance)
          }
          // trigger_proximity_exit
          if (sequence.trigger.trigger_type.value == 'trigger_proximity_exit' && sequence.targets) {
            el.elements[0].targets = Array.from(sequence.targets, target => target.value)
            el.elements[0].distance = parseFloat(sequence.distance)
          }
          if (sequence.actions != null && sequence.actions.length > 0) {
            // Add target to sequence trigger if needed
            // targets: [sequence.target != null && sequence.target.value != null ? sequence.target.value : null],

            for (let index = 0; index < sequence.actions.length; index++) {
              const action = sequence.actions[index]
              if (index == sequence.actions.length - 1 || sequence.actions[index + 1].start.value == 'after_previous') {
                el.elements.push(this.buildJsonSequenceElement(action))
              } else if (sequence.actions[index + 1].start.value == 'with_previous') {
                var parallel_actions = []
                parallel_actions.push(sequence.actions[index])
                index++
                parallel_actions.push(sequence.actions[index])
                let i = index + 1
                while (i < sequence.actions.length && sequence.actions[i].start.value == 'with_previous') {
                  parallel_actions.push(sequence.actions[i])
                  index++
                  i++
                }
                el.elements.push(this.buildJsonparallel(parallel_actions))
              } else {
                continue
              }
            }
          }
          json.push(el)
        }
      })
      return json
    },
    isValid: function(sequencing) {
      if (sequencing == null || !(sequencing.length > 0)) {
        // console.log('isValid false')
        return false
      } else {
        // console.log('isValid true')

        return true
      }
    },
    async SelectAction(action_id) {
      this.selected_action = this.selected_actions.find(a => a.id == action_id)
      console.log('SelectAction')
      console.log(this.selected_action)

      // Populate animation clip names
      if (
        this.selected_action.type == 'action_animate' &&
        this.getHobjectAnimationFromNodePid(this.selected_action.targets[0].value) &&
        this.getHobjectAnimationFromNodePid(this.selected_action.targets[0].value).length > 0
      ) {
        this.action_animate_form_schema[0].type = 'select'
        var anims = {}
        this.getHobjectAnimationFromNodePid(this.selected_action.targets[0].value).forEach(a => {
          anims[a] = a
        })
        this.action_animate_form_schema[0].options = anims
      } else {
        this.action_animate_form_schema[0].type = 'text'
      }
    },
    ShowAction(action_id, a) {
      this.selected_actions.forEach(a => {
        if (a.id != action_id) a.show = false
      })
      console.log('ShowAction')
      var action = this.selected_actions.find(a => a.id == action_id)
      console.log(a.show)
      if (action) {
        if (action.show == true) action.show = false
        else action.show = true
      }
      // console.log(action.show)
    },
    Back() {
      this.$router.go(-1)
    },
    onEvents(e) {
      this.selected_action[e.name] = e.payload
    },
    // Sequence Name Editing
    enableSequenceNameEditing: function(existingSequenceName) {
      this.temp_sequence_name = existingSequenceName
      this.is_sequence_name_editing = true
    },
    disableSequenceNameEditing: function() {
      this.temp_sequence_name = null
      this.is_sequence_name_editing = false
    },
    saveSequenceNameEdit: function() {
      this.selected_trigger.name = this.temp_sequence_name
      this.disableSequenceNameEditing()
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/components/vxTimeline.scss';
.con-vs-tabs .con-slot-tabs {
  overflow: visible !important;
}
.con-vs-tabs {
  overflow: visible !important;
}
.border-dots {
  border-width: 1px;
  padding: 10px;
  // border: dashed #ecebfa;
  border: solid #d6d6d6;

  border-radius: 5px;
}
.vx-timeline > li {
  background-color: #f7f6fe;
}
.vx-timeline > div > li {
  background-color: #f7f6fe;
}
.vx-timeline > li:hover {
  background-color: #e6e4fc;
  border-radius: 5px;
}
.action-title-highlight:hover {
  color: #2614ed;
}
.vx-timeline > div > li:hover {
  background-color: #e6e4fc;
  border-radius: 5px;
}
.open-item > .vs-collapse-item--content {
  max-height: 99999px !important;
}
.open-item > * {
  overflow: visible !important;
}

.vx-timeline {
  li {
    margin-bottom: 0px;
  }
}

.hover:hover {
  text-decoration: underline;
}

// form schema
.formulate-input {
  margin-bottom: 0.5rem !important;
}
.formulate-input[data-classification='box'] .formulate-input-wrapper {
  display: flex;
  align-items: center;
}
.formulate-input[data-classification='box'] .formulate-input-label--after {
  margin-left: 0.5em;
}
.formulate-input .formulate-input-label {
  margin-bottom: 0.1em;
}
.icon-size > i {
  font-size: 1.3rem;
}
.flex {
  display: flex;
  flex-wrap: wrap;
}
.text-gray {
  color: #8b8b8b;
}
/* Timeline Container */
.timeline {
  background: var(--primary-color);
  // margin: 20px auto;
  // padding: 20px;
}

/* Outer Layer with the timeline border */
.outer {
  border-left: 2px solid rgb(166, 166, 166);
}

/* Card container */
.card {
  position: relative;
  margin: 0 0 20px 20px;
  padding: 10px;
  background-color: #f7f6fe;
  color: gray;
  border-radius: 8px;
  max-width: 400px;
  border-width: 1px;
  border: solid #d6d6d6;
}
.selected-card {
  background-color: #e6e2ff;
}
/* Information about the timeline */
.info {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

/* Title of the card */
.title {
  color: orangered;
  position: relative;
}

/* Timeline dot  */
.title::before {
  content: '';
  position: absolute;

  width: 6px;
  height: 6px;
  background: white;
  border-radius: 999px;
  left: -39px;
  border: 3px solid rgb(166, 166, 166);
}
.header-sequence {
  display: flex;
  justify-content: space-between;
}
</style>
